<div class="pdf-viewer">
    <div class="loader nested" *ngIf="pageStatus == STATUS_LOADING">
        <div class="dimmed">
            <div class="dimmed_box"></div>
            <div class="dimmed_box_large"></div>
        </div>
    </div>
    
    <core-helpers-box-alert-message-icon [hidden]="pageStatus != STATUS_NOT_FOUND" [text]="'No preview available'"
        [icon]="'alert'"></core-helpers-box-alert-message-icon>

    <core-helpers-box-alert-message-icon [hidden]="pageStatus != STATUS_ERROR" [text]="'No notes available'"
        [icon]="'warning'"></core-helpers-box-alert-message-icon>
    
    <div #pdfAnnotatorViewer style="height:100vh" id="pdfviewer" [hidden]="pageStatus != STATUS_DONE && pageStatus != STATUS_LOADING" >
    </div>
</div>